<div class="container container-shadow py-3 px-3">
  <div class="text-center" *ngIf="loading">
    <i class="fas fa-spinner fa-pulse fa-3x"></i>
  </div>
  <div *ngIf="!loading">
    <h3 class="bg-white p-1 mb-2">{{ userIncomeInfo.name }}</h3>
    <h4 class="bg-primary p-1 mb-3">
      <a class="text-white" [routerLink]="'/matters/' + userIncomeInfo.matter_id">{{ userIncomeInfo.matter_name }}</a>
    </h4>
    <div class="float-right pl-2">
      <h5 class="bg-dark text-white p-1">Share of income: {{ shareOfIncome | currency: 'USD':'symbol-narrow':'1.2-2' }}</h5>
    </div>
    <div class="float-right">
      <h5 class="bg-dark text-white p-1">Income due: {{ incomeDueCount }}</h5>
    </div>
    <pagination class="pagination-sm" (pageChanged)="loadIncomeDue($event)" [boundaryLinks]="true" [totalItems]="incomeDueCount" [maxSize]="5" [(ngModel)]="params.page" [itemsPerPage]="params.per_page" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
    <div class="row">
      <div class="col-1 text-center"><h5>Id</h5></div>
      <div class="col-1 text-center"><h5>Invoice</h5></div>
      <div class="col-1 text-center"><h5>Date</h5></div>
      <div class="col-4"><h5>Description</h5></div>
      <div class="col-2"><h5>Charged By</h5></div>
      <div class="col-1 text-center"><h5>Amount</h5></div>
      <div class="col-2"><h5>Paid?</h5></div>
    </div>
    <div>
      <div class="row py-3 odd-color-mute" *ngFor="let bill of incomeDue" style="font-size: 85%">
        <div class="col-1 text-center">
          <a [href]="'/bills/' + bill.id">{{ bill.id }}</a>
        </div>
        <div class="col-1 text-center">
          <a [href]="'/invoices/' + bill.invoice_id" *ngIf="bill.invoice_id > 0">{{ bill.invoice_id }}</a>
        </div>
        <div class="col-1 text-center" [title]="bill.created_at_time" [tooltip]="bill.created_at_time">
          {{ bill.created_at_date }}
        </div>
        <div class="col-4" [innerHTML]="bill.description | safeHtml"></div>
        <div class="col-2">
          {{ bill.user_name }}
        </div>
        <div class="col-1 text-right">
          {{ bill.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}
        </div>
        <div class="col-2">
          <span *ngIf="bill.is_paid"><img [src]="userIncomeInfo.coins_asset" /></span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="py-5"></div>
